var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100 menu-button flex-l-c",attrs:{"title":_vm.text},on:{"click":_vm.onClick}},[_c('i',{class:_vm.icon}),(!_vm.isCollapse)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }